
import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { checkMoneyEl } from "@common/src/utils/verify";
import AmountDiffTips from "./amount-diff-tips-dialog.vue";

const finance = namespace("finance");
const app = namespace("app");
const setting = namespace("setting");
const marketing = namespace("marketing");

@Component({ components: { AmountDiffTips } })
export default class ReceivePaymentDialog extends Vue {
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @finance.Action createDeferredCycle;
  @finance.Action queryDeferredCycleList;
  @finance.Action deferredRepayment;
  @setting.Action getPatternPaymentList;
  @marketing.Action queryCustomerCard;

  @Ref("AmountDiffTips") AmountDiffTips;

  @Prop({ default: () => ({}), type: Object })
  filterParams: any;

  @Prop({ default: () => ({}), type: Object })
  sumData: any;

  @Prop({ default: 0, type: Number || String })
  total: any;

  @Prop({ default: "multiple", type: String })
  scope: "multiple" | "single";

  @Ref("fromRef") fromRef;

  cycleList = [];
  definitionNewItem = {
    billingCycleName: "",
    billingCycleValue: "",
    new: true
  };
  payWayList = [];
  created() {
    this.getPatternPaymentList({
      status: "1",
      scene: "20"
    }).then(async res => {
      this.payWayList = res?.data || [];
    });
  }

  handleInsertRow(index) {
    this.cycleList.splice(index + 1, 0, Object.assign({}, this.definitionNewItem));
  }
  handleDeleteRow(index) {
    if (this.cycleList.length > 1) {
      this.cycleList.splice(index, 1);
    } else {
      this.$message.warning("最少设置第一个周期");
    }
  }
  form = {
    queryParam: null,
    count: 0,
    paymentMethod: "",
    repaymentAmount: "",
    discountAmount: "",
    remark: ""
  };
  formRules = {
    paymentMethod: [{ required: true, message: "请选择" }],
    repaymentAmount: {
      required: true,
      validator: (rule, value, callback) => {
        checkMoneyEl(value, callback);
      }
    },
    discountAmount: {
      required: false,
      validator: (rule, value, callback) => {
        checkMoneyEl(value, callback, true);
      }
    }
  };
  visible = false;
  async open(rowCustomerCode) {
    this.visible = true;
    await this.getCycleList();
    if (!this.cycleList.length) {
      this.handleInsertRow(0);
    }
    this.form.repaymentAmount = this.sumData.sumDueAmount;
    this.form.remark = "";
    this.form.discountAmount = "";
    if (rowCustomerCode) {
      await this.queryValueCardTotalBalance(rowCustomerCode);
      this.payWayList = this.payWayList.map(item => {
        if (item.payMethodCode === "6") {
          item.payMethodNameCopy = `${item.payMethodName}(余额: ${this.balance})`;
        } else {
          item.payMethodNameCopy = `${item.payMethodName}`;
        }
        return item;
      });
    }
  }
  getCycleList() {
    return this.queryDeferredCycleList().then(res => {
      this.cycleList = res?.data || [];
    });
  }
  async handleConfirmReceive() {
    try {
      await this.fromRef.validate();
      const { paymentMethod, repaymentAmount, discountAmount } = this.form;
      const { sumDueAmount } = this.sumData;
      if (Number(repaymentAmount) > Number(sumDueAmount)) {
        return this.$message.error("收款金额大于挂账金额，多余金额可手工创建储值卡做预收处理。");
      } else if (Number(repaymentAmount) + Number(discountAmount || 0) > Number(sumDueAmount)) {
        return this.$message.error("挂账金额不为0时,收款金额+坏账金额必须等于合计待收金额");
      } else if (Number(repaymentAmount) + Number(discountAmount || 0) < Number(sumDueAmount)) {
        if (Number(discountAmount || 0)) {
          return this.$message.error("挂账金额不为0时,收款金额+坏账金额必须等于合计待收金额");
        }
        this.AmountDiffTips.open();
        return;
      }
      if (paymentMethod === "6") {
        if (this.balance < Number(repaymentAmount)) {
          return this.$message.error("储值卡余额不足");
        }
      }
      this.confirmRepayment();
    } catch (e) {
      //
    }
  }
  confirmRepayment() {
    const { paymentMethod, repaymentAmount, discountAmount, remark } = this.form;
    this.btnStartLoading();
    this.deferredRepayment({
      queryParam: this.filterParams,
      count: this.scope === "multiple" ? this.total : 1,
      paymentMethod,
      repaymentAmount,
      discountAmount,
      remark
    })
      .then(() => {
        this.$message.success("收款成功");
        this.AmountDiffTips.close();
        this.closeReset();
        this.$emit("Successfully");
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  closeReset() {
    this.visible = false;
    this.form.paymentMethod = "";
  }
  handleContinue() {
    this.confirmRepayment();
  }
  balance = 0;
  queryValueCardTotalBalance(customerCode) {
    if (customerCode) {
      return this.queryCustomerCard({
        cardType: "2",
        customerCode: customerCode
      }).then(data => {
        this.balance = Number(data.data?.balance || 0);
      });
    }
  }
}
